import type { MetaOnboardingPageView } from '@hilo/contracts';

export function pageProblem(page: MetaOnboardingPageView): string | null {
  if (page.active) return 'Ya conectada';
  if (page.blocked) return 'Ya está conectada de otra forma: Hilo no la modifica.';
  if (!page.canMessage) return 'No tienes la tarea de mensajes en esta página.';
  if (!page.canSubscribe) return 'No tienes una tarea de administración en esta página (administrar, moderar o crear contenido).';
  return null;
}

export function selectedPage(pages: MetaOnboardingPageView[], chosen: string | null): string | null {
  const selectable = pages.filter((page) => pageProblem(page) === null);
  return selectable.find((page) => page.pageId === chosen)?.pageId ?? selectable[0]?.pageId ?? null;
}

export function nextPage(pages: MetaOnboardingPageView[], selected: string | null, key: string): string | null {
  const selectable = pages.filter((page) => pageProblem(page) === null);
  const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[key];
  if (selectable.length === 0) return null;
  const index = selectable.findIndex((page) => page.pageId === selected);
  const target = key === 'Home' ? 0 : key === 'End' ? selectable.length - 1
    : step === undefined ? null : (index + step + selectable.length) % selectable.length;
  return target === null ? null : selectable[target]!.pageId;
}
